import { createAction, createAsyncThunk } from "@reduxjs/toolkit"
import { SearchResponse } from "./search-response"

// Defined here to prevent circular dependencies.
// Both the search thunk and the slices require these actions/types,
// but because the thunk also depends on the slices, isolating
// these shared actions here keeps the import graph clean.
export const searchAsyncThunk = createAsyncThunk(
  "search",
  (searchPromise: Promise<SearchResponse>) => searchPromise,
)
export const searchPending = searchAsyncThunk.pending
export const searchRejected = searchAsyncThunk.rejected
export const searchFulfilled = searchAsyncThunk.fulfilled

export const allFiltersCleared = createAction("search/allFiltersCleared")
